<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Freight Factory Execution</b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="ALLMODULE"
          :jobSeriesBanner="JOBSERIES"
          :bannerClientName="mainEntryData.length > 0 ? mainEntryData[0].clientName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2">
              <!-- <b-button
                size="sm"
                variant="outline-info"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
              >Hide Details</b-button>-->
              <!-- <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                <b-card class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{mainEntryData[0].clientName}}
                          <br>
                        </b>
                        <b>
                          Assignment No. : {{mainEntryData[0].ffExportFclSeries}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <b>
                          FF Activity : {{mainEntryData[0].containerInfo}}
                          <br>
                        </b>
                        <b>
                          Stuffing Type : {{mainEntryData[0].stuffingType}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                      
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-collapse>
          
            <hr> -->
            </div>
            <div
              v-if="
                ffExportDetail.stuffingType == 'factoryStuffing' &&
                ffExportDetail.containerInfo == 'fcl'
              "
            >
              <md-layout gutter>
                <md-layout md-flex="35">
                  <h5>
                    <b-badge
                      >Factory Stuffing at
                      {{ ffExportDetail.portType == "Icd" ? "ICD" : "PORT" }}</b-badge
                    >
                  </h5>
                </md-layout>
              </md-layout>

              <div class="mt-3" v-if="containerTypeDetailFactoryList.length > 0">
                <!-- /.box-header -->

                <h5 class="box-title">
                  <b-badge>Container Details</b-badge>
                </h5>
                <table id="ffContainer" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Container No</th>
                      <th>Container Type</th>

                      <th>Custom Seal No</th>
                      <th>Line Seal No</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in containerTypeDetailFactoryList"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td
                        @click="viewEdit(item.ffExecutionContainerId, index)"
                        class="showMoreData"
                      >
                        {{ item.containerNo }}
                      </td>

                      <td
                        @click="viewEdit(item.ffExecutionContainerId, index)"
                        class="showMoreData"
                      >
                        {{ item.containerType }}
                      </td>
                      <td>{{ item.customSealNo }}</td>
                      <td>{{ item.LineSealNo }}</td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  <div
                    class="gutr"
                    v-for="(type1, index) in containerCountWise"
                    :key="index"
                  >
                    <md-chip
                      style="margin-right: 4px"
                      class="pull-right"
                      v-if="type1.totalCount != 0"
                    >
                      <span v-if="type1.totalCount != 0" style="color: #0e0052"
                        >{{ type1.containerType }} -</span
                      >
                      <span v-if="type1.totalCount != 0" style="color: red"
                        >{{ type1.totalCount }} Left</span
                      >
                    </md-chip>
                  </div>
                </div>

                <!-- /.box-body -->
              </div>
              <div
                class="gutr"
                v-if="
                  getContainerList.length > 0 ||
                  ContainerTypeSizefactory.ffExecutionContainerId != ''
                "
              >
                <b-card style="background: whiteSmoke">
                  <!-- <md-layout md-gutter>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="95">
                        <label>
                          <b>
                            <u>Container Details</u>
                          </b>
                          <span
                            class="error"
                            v-if="containerTypeDetailFactory.length==0"
                          >{{errorAtleastContainer}}</span>
                        </label>
                      </md-layout>
                    </md-layout> -->
                  <!-- <md-layout md-gutter class="gutr" v-if="ContainerFromTPT.length>0">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label for="itemDescription">Container Details From TPT</label>

                          <b-form-textarea :formatter="capitalizeAll"
                            disabled
                            id="remark"
                            name="remark"
                            v-model="conDetailsTPT"
                            style="height:50px"
                          ></b-form-textarea>
                        </md-layout>
                      </md-layout>
                    </md-layout>-->
                  <!-- <md-layout md-gutter v-if="showDivCountNote">
              <md-layout md-flex="60"></md-layout>
              <md-layout md-flex="5">
                <label style="margin:5px">
                  <u>Note</u>
                </label>
              </md-layout>
              <md-layout md-flex="25" v-if="containerCountWise.length>0">
                <div v-for="(type1,index) in containerCountWise" :key="index">
                  <md-chip style="margin-right:4px;" v-if="type1.totalCount !=0 ">
                    <span
                      v-if="type1.totalCount !=0 "
                      style="color:#0e0052"
                    >{{type1.containerType}} -</span>
                    <span v-if="type1.totalCount!=0" style="color:red">{{type1.totalCount}} Left</span>
                  </md-chip>
                </div>
              </md-layout>
                    </md-layout>-->
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="50">
                      <label v-if="ContainerTypeSizefactory.ffExecutionContainerId == ''"
                        >Container Type/Size</label
                      >
                      <model-list-select
                        v-if="ContainerTypeSizefactory.ffExecutionContainerId == ''"
                        option-value="containerTypeId"
                        option-text="containerType"
                        :list="ContainerTypeList"
                        placeholder="Select Container Type/Size"
                        v-model="ContainerTypeSizefactory.containerTypeId"
                      ></model-list-select>
                      <md-layout md-flex="100" v-else>
                        <label for="containerType">Container Type/Size</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="ContainerTypeSizefactory.containerType"
                          disabled
                        ></b-form-input>
                      </md-layout>
                      <span
                        class="error"
                        v-if="!ContainerTypeSizefactory.containerTypeId"
                        >{{ errorContainer.containerTypeId }}</span
                      >
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Container No. (eg. AAAA1234567)</label>

                        <b-form-input
                          :formatter="capitalizeAll"
                          maxlength="11"
                          name="containerNo"
                          v-model="ContainerTypeSizefactory.containerNo"
                          @keyup="containerNoRegexfun"
                        ></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!ContainerTypeSizefactory.containerNo">{{
                        errorContainer.containerNo
                      }}</span>
                      <span class="error" v-else-if="containerNoRegexError != ''">{{
                        containerNoRegexError
                      }}</span>
                      <span
                        class="error"
                        v-if="
                          containerNoRegexError == '' &&
                          ContainerTypeSizefactory.containerNo != '' &&
                          ContainerTypeSizefactory.containerNo != algoConNo &&
                          showAlgo == true
                        "
                        >Note:System Generated Container No. is : {{ algoConNo }}</span
                      >
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="30">
                      <md-layout md-flex="100">
                        <label>Line Seal No</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="LineSealNo"
                          name="LineSealNo"
                          v-model="ContainerTypeSizefactory.LineSealNo"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <md-layout md-flex="100">
                        <label>Container Tare Wgt.</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="tareWeight"
                          name="tareWeight"
                          type="number"
                          min="0"
                          v-model="ContainerTypeSizefactory.tareWeight"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="10">
                      <md-layout md-flex="100">
                        <label>Net Wgt.</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="netWeight"
                          name="netWeight"
                          type="number"
                          min="0"
                          v-model="ContainerTypeSizefactory.netWeight"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="10">
                      <md-layout md-flex="100">
                        <label>Gross Wgt.</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="grossWeight"
                          name="grossWeight"
                          type="number"
                          min="0"
                          v-model="ContainerTypeSizefactory.grossWeight"
                        ></b-form-input>
                      </md-layout>

                      <span class="error" v-if="!ContainerTypeSizefactory.grossWeight">{{
                        errorContainer.grossWeight
                      }}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label for="weightUnit">Unit</label>
                      <model-list-select
                        :list="unitList"
                        option-value="uV"
                        option-text="uT"
                        placeholder="Select Unit"
                        name="weightUnit"
                        id="weightUnit"
                        v-model="ContainerTypeSizefactory.weightUnit"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="50">
                      <label>Pickup Location</label>

                      <model-list-select
                        @input="getLocationList($event, 'All', 'pickUpListpickUpList')"
                        @searchchange="getLocationList($event, 'All', 'pickUpList')"
                        :list="pickUpList"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Search PickUp Location"
                        name="PickupLocation"
                        id="PickupLocation"
                        v-model="ContainerTypeSizefactory.PickupLocation"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <label>Handover Location</label>

                      <model-list-select
                        @input="getLocationList($event, 'All', 'handoverList')"
                        @searchchange="getLocationList($event, 'All', 'handoverList')"
                        :list="handoverList"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Handover Location"
                        name="StuffingLocation"
                        id="StuffingLocation"
                        v-model="ContainerTypeSizefactory.StuffingLocation"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="50">
                      <label>Package Details</label>
                      <model-list-select
                        :list="packageNameList"
                        id="clientId"
                        v-model="ContainerTypeSizefactory.packageId"
                        option-value="packageId"
                        option-text="packageName"
                        placeholder="Select  Package Name"
                      ></model-list-select>

                      <span class="error" v-if="!ContainerTypeSizefactory.packageId">{{
                        errorContainer.packageId
                      }}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label
                          >No. of Packages ({{
                            ContainerTypeSizefactory.packageName
                          }})</label
                        >
                        <b-form-input
                          :formatter="capitalizeAll"
                          name="noOfpkgUnit"
                          id="noOfpkgUnit"
                          type="number"
                          min="0"
                          :disabled="
                            ContainerTypeSizefactory.packageName == '' ? true : false
                          "
                          v-model="ContainerTypeSizefactory.noOfpkgUnit"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="!ContainerTypeSizefactory.noOfpkgUnit"
                          >{{ errorContainer.noOfpkgUnit }}</span
                        >
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>Measurement (in CBM)</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          name="noOfpkgUnit"
                          id="noOfpkgUnit"
                          type="number"
                          min="0"
                          v-model="ContainerTypeSizefactory.measurement"
                        ></b-form-input>
                        <!-- <span
                    class="error"
                    v-if="!ContainerTypeSizefactory.measurement"
                          >{{errorContainer.measurement}}</span>-->
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <label>Custom Seal No</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="customSealNo"
                          name="customSealNo"
                          v-model="ContainerTypeSizefactory.customSealNo"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <label>Pickup Date</label>
                      <date-picker
                        :format="selectDateFormat"
                        lang="en"
                        id="pickupDate"
                        :minute-step="1"
                        name="pickupDate"
                        v-model="ContainerTypeSizefactory.pickupDate"
                      ></date-picker>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <label>Stuffing Date</label>
                      <date-picker
                        :format="selectDateFormat"
                        lang="en"
                        id="stuffingDate"
                        :minute-step="1"
                        name="stuffingDate"
                        v-model="ContainerTypeSizefactory.stuffingDate"
                      ></date-picker>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter>
                    <md-layout md-flex="85"></md-layout>
                    <md-layout md-flex="15">
                      <b-button
                        variant="info"
                        size="sm"
                        id="addButtonLoaderCon"
                        style="margin-top: -40px"
                        @click="factoryStuffingContainer"
                        >{{
                          editIndex == "" &&
                          (editIndex != 0 || editIndex != "0") &&
                          ContainerTypeSizefactory.ffExecutionContainerId == ""
                            ? "Add"
                            : "Update"
                        }}
                        Container</b-button
                      >
                      <md-spinner
                        md-indeterminate
                        id="loaderCon"
                        style="display: none"
                      ></md-spinner>
                    </md-layout>
                  </md-layout>
                </b-card>
              </div>

              <div v-if="proceedFurther == true">
                <div class="mt-4" v-if="sbDetailArrayList.length > 0">
                  <!-- /.box-header -->

                  <h5 class="box-title">
                    <b-badge>Shipping Bill Details</b-badge>
                    <b-button
                      size="sm"
                      class="pull-right"
                      @click="showDocModal"
                      variant="dark"
                      >Upload SB Documents</b-button
                    >
                  </h5>
                  <table id="SBDetailr" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Shipper Invoice No.</th>
                        <th>Shipping Bill No</th>
                        <th>Cargo Gross Weight</th>

                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in sbDetailArrayList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.shippingInvoiceNo }}</td>
                        <td>{{ item.shippingBillNo }}</td>
                        <td>{{ item.cargoGrossWeight }}</td>

                        <td>
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="viewEditSB(item.shippingSBId, index)"
                          >
                            <md-icon>edit</md-icon>
                          </md-button>
                        </td>
                        <td>
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="DeleteListSb(item.shippingSBId, index)"
                          >
                            <md-icon>delete_sweep</md-icon>
                          </md-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- /.box-body -->
                </div>
                <md-layout md-gutter v-if="getContainerList.length == 0">
                  <md-layout md-flex="30">
                    <b-button
                      class="mt-2"
                      variant="outline-dark"
                      size="sm"
                      :disabled="permissionStatus ? true : false"
                      @click="showMoreSBDet"
                      >{{ showMoreSB == true ? "Hide" : "Add" }} Shipping Bill
                      Details</b-button
                    >
                    <b-button
                      class="mt-2 ml-1"
                      variant="outline-dark"
                      size="sm"
                      @click="showDocModal"
                      >Upload SB Documents</b-button
                    >
                    <md-spinner
                      md-indeterminate
                      id="loader1"
                      style="display: none"
                    ></md-spinner>
                  </md-layout>
                </md-layout>
                <div
                  class="gutr"
                  v-if="
                    getContainerList.length > 0 ||
                    SBDetail.shippingSBId != '' ||
                    showMoreSB
                  "
                >
                  <b-card style="background: whiteSmoke">
                    <md-layout md-gutter>
                      <md-layout md-flex="95">
                        <h5>
                          <b-badge>Shipping Details</b-badge>
                        </h5>
                        <span class="error" v-if="sbDetailArrayList.length == 0">{{
                          errorAtleastSb
                        }}</span>
                      </md-layout>
                    </md-layout>

                    <md-layout gutter>
                      <!-- <md-layout md-flex="45">
                        <md-input-container>
                          <label>Invoice From Shipper</label>
                          <md-file
                            name="invoiceUpload"
                            id="invoiceUpload"
                            v-model="SBDetail.invoiceUpload"
                            @selected="onFileChange('Invoice')"
                          ></md-file>
                        </md-input-container>
                      </md-layout> -->

                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Shipper Invoice No.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="shippingInvoiceNo"
                            id="shippingInvoiceNo"
                            v-model="SBDetail.shippingInvoiceNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Invoice Date.</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          name="shippingBillDate"
                          id="shippingBillDate"
                          v-model="SBDetail.shippingInvoiceDate"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter>
                      <div v-if="viewInvoicedDoc.length > 0">
                        <md-layout
                          md-flex="20"
                          v-for="(item, index) in viewInvoicedDoc"
                          :key="index"
                        >
                          <!-- :href="'http://13.229.240.246/FFExecutionSBWareHouse/'+item" -->
                          <a
                            :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                            target="_blank"
                            download
                            >View old Document - {{ index + 1 }}</a
                          >
                        </md-layout>
                      </div>
                    </md-layout>

                    <md-layout md-gutter>
                      <!-- <md-layout md-flex="45">
                        <md-input-container>
                          <label>Cargo Packing List</label>
                          <md-file
                            name="cargoUpload"
                            id="cargoUpload"
                            v-model="SBDetail.cargoUpload"
                            @selected="onFileChange('Cargo')"
                          ></md-file>
                        </md-input-container>
                      </md-layout> -->
                      <!-- <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="50">
                        <md-input-container>
                          <label> Shipping Bill</label>
                          <md-file
                            @selected="onFileChange('Shipping')"
                            name="cargoUpload"
                            id="cargoUpload"
                            v-model="SBDetail.shippingBillUpload"
                          ></md-file>
                       
                        </md-input-container>
                      </md-layout> -->
                    </md-layout>

                    <md-layout md-gutter>
                      <div v-if="viewCargoDoc.length > 0">
                        <md-layout
                          md-flex="30"
                          v-for="(item, index) in viewCargoDoc"
                          :key="index"
                        >
                          <!-- :href="'http://13.229.240.246/FFExecutionSBWareHouse/'+item" -->
                          <a
                            :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                            target="_blank"
                            download
                            >View Document - {{ index + 1 }}</a
                          >
                        </md-layout>
                      </div>
                      <md-layout md-flex="40"></md-layout>
                      <div v-if="viewShippingdDoc.length > 0">
                        <md-layout
                          md-flex="30"
                          v-for="(item, index) in viewShippingdDoc"
                          :key="index"
                        >
                          <a
                            :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                            target="_blank"
                            download
                            >View Document - {{ index + 1 }}</a
                          >
                        </md-layout>
                      </div>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Shipping Bill No.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="shippingBillNo"
                            id="shippingBillNo"
                            v-model="SBDetail.shippingBillNo"
                          ></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!SBDetail.shippingBillNo">{{
                          errorSBExecution.shippingBillNo
                        }}</span>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="15">
                        <label>Shipping Bill Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          name="shippingBillDate"
                          id="shippingBillDate"
                          v-model="SBDetail.shippingBillDate"
                          :minute-step="1"
                        ></date-picker>
                        <span class="error" v-if="!SBDetail.shippingBillDate">{{
                          errorSBExecution.shippingBillDate
                        }}</span>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="50">
                        <md-layout md-flex="100">
                          <label>Cargo Gross Weight(KGS)</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="cargoGrossWeight"
                            type="number"
                            min="0"
                            id="cargoGrossWeight"
                            v-model="SBDetail.cargoGrossWeight"
                          ></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!SBDetail.cargoGrossWeight">{{
                          errorSBExecution.cargoGrossWeight
                        }}</span>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class="gutr">
                      <md-layout md-flex="25">
                        <label for="examinationComplete">Examination Complete</label>
                        <model-list-select
                          :list="examinationList"
                          option-value="examValue"
                          option-text="examText"
                          placeholder="Select Examination"
                          name="examinationComplete"
                          id="examinationComplete"
                          v-model="SBDetail.examinationComplete"
                        ></model-list-select>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>

                      <md-layout
                        md-flex="15"
                        v-if="SBDetail.examinationComplete == 'Yes'"
                      >
                        <label>Examination Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          id="examDate"
                          :minute-step="1"
                          name="examDate"
                          v-model="SBDetail.examDate"
                        ></date-picker>
                      </md-layout>
                      <!--   <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label for="EnterLet">LET Export Permit</label>
                            <b-form-input :formatter="capitalizeAll" name="EnterLet" v-model="SBDetail.EnterLet" id="EnterLet"></b-form-input>
                          </md-layout>
                        </md-layout>-->
                      <md-layout md-flex="5"></md-layout>

                      <md-layout
                        md-flex="15"
                        v-if="SBDetail.examinationComplete == 'Yes'"
                      >
                        <label>LET Export Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          id="LetExport"
                          :minute-step="1"
                          name="LetExport"
                          v-model="SBDetail.LetExport"
                        ></date-picker>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="gutr">
                      <md-layout md-flex="85"></md-layout>
                      <md-layout md-flex="15">
                        <b-button
                          variant="info"
                          size="sm"
                          id="addButtonLoaderSB"
                          @click="addSBDetail"
                          >{{ SBDetail.shippingSBId == "" ? "Add " : "Edit" }} Shipping
                          Bill</b-button
                        >
                        <md-spinner
                          md-indeterminate
                          id="loaderSB"
                          style="display: none"
                        ></md-spinner>
                      </md-layout>
                    </md-layout>
                  </b-card>
                </div>

                <div v-if="sbDetailArrayList.length > 0">
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="15">
                      <label style="margin: 0px">
                        <b>Transportation By :</b>
                      </label>
                      <span class="error" v-if="!factoryStuffing.transportationBy">{{
                        errorExecution.transportationBy
                      }}</span>
                    </md-layout>

                    <md-layout md-flex="10" class="gutr">
                      <md-radio
                        id="isKYC1"
                        name="isKYC1"
                        v-model="factoryStuffing.transportationBy"
                        md-value="Pridel"
                        class="md-primary margn-0px"
                        >Pridel</md-radio
                      >
                    </md-layout>

                    <md-layout md-flex="10" class="gutr">
                      <md-radio
                        id="isKYC2"
                        name="isKYC2"
                        v-model="factoryStuffing.transportationBy"
                        md-value="Shipper"
                        class="md-primary margn-0px"
                        >Shipper</md-radio
                      >
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="20">
                      <label>VGM Submission Date</label>
                      <date-picker
                        :format="selectDateFormat"
                        lang="en"
                        name="vgmSubmissionDate"
                        id="vgmSubmissionDate"
                        v-model="factoryStuffing.vgmSubmissionDate"
                        :minute-step="1"
                      ></date-picker>
                    </md-layout>
                  </md-layout>
                  <!-- <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="30">
                    <label for="CustomerGateIn">Container Gate-In ICD Location</label>

                    <model-list-select
                      @input="getLocationList($event,'All','customerGateLocaList')"
                      @searchchange="getLocationList($event,'All','customerGateLocaList')"
                      :list="customerGateLocaList"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      placeholder="Search  Location"
                      name="CustomerGateIn"
                      id="CustomerGateIn"
                      v-model="factoryStuffing.CustomerGateIn"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!factoryStuffing.CustomerGateIn"
                    >{{errorExecution.CustomerGateIn}}</span>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label for="gateInDate">Gate-In date time</label>
                    <date-picker
                      :disabled="factoryStuffing.vgmSubmissionDate==''"
                      lang="en"
                      id="gateInDate"
                      type="datetime"
                      format="YYYY-MM-DD hh:mm a"
                      :minute-step="1"
                      name="gateInDate"
                      v-model="factoryStuffing.gateInDate"
                    ></date-picker>
                  
                  </md-layout>
                 
                  </md-layout>-->
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="20">
                      <label>SI Submission Submission Date</label>
                      <date-picker
                        :format="selectDateFormat"
                        lang="en"
                        name="siSubmissionDate"
                        id="siSubmissionDate"
                        v-model="factoryStuffing.siSubmissionDate"
                        :minute-step="1"
                      ></date-picker>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <label for="vgmBy">VGM By</label>
                      <model-list-select
                        @input="addVgmByShipper"
                        :list="vgmByList"
                        option-value="vgmByValue"
                        option-text="vgmByText"
                        placeholder="Select"
                        name="vgmBy"
                        id="vgmBy"
                        v-model="factoryStuffing.vgmBy"
                      ></model-list-select>
                    </md-layout>
                    <b-button
                      size="sm"
                      style="margin-top: 35px !important"
                      v-if="factoryStuffing.vgmBy == 'SHIPPER'"
                      @click="showDocModal"
                      variant="dark"
                      >Upload Shipper VGM</b-button
                    >
                    <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" v-if="factoryStuffing.vgmBy=='SHIPPER'">
                      <md-input-container>
                          <label>Signed VGM by Shipper If Any</label>
                        <md-file
                         
                          name="vgmUpload"
                          id="vgmUpload"
                          v-model="factoryStuffing.vgmUpload"
                        @selected="onFileChange('VGMBYSHIPPER')"
                          
                        ></md-file>
                      </md-input-container>
                    </md-layout> -->
                  </md-layout>
                  <!-- <table
                    id="SBDetailr"
                    class="table table-bordered mt-3"
                    v-if="
                      factoryStuffing.vgmBy == 'SHIPPER' ||
                      vgmArryList.length > 0
                    "
                  >
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Container No.</th>
                        <th>VGM</th>
                        <th>View</th>
                        <th>
                          <b-button
                            @click="addMoreDoc"
                            variant="outline-primary"
                            size="sm"
                            >Add More</b-button
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in vgmArryList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <b-form-input :formatter="capitalizeAll"
                            name="cargoGrossWeight"
                            id="cargoGrossWeight"
                            v-model="item.vgmContainerNo"
                          ></b-form-input>
                        </td>
                        <td>
                          <md-input-container>
                            <md-file
                              placeholder="Upload Signed VGM by Shipper If Any"
                              name="vgmUpload"
                              id="vgmUpload"
                              v-model="item.vgmUpload"
                              @selected="onFileChangeVgm(index)"
                              multiple
                            ></md-file>
                          </md-input-container>
                        </td>
                        <td>
                          <a
                            :href="
                              `${docURL}/FF_Sea_Export_Uploads/` +
                              item.viewVgm
                            "
                            target="_blank"
                            download
                            >View Document</a
                          >
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table> -->
                  <!-- <md-layout md-gutter v-if="viewVgmDoc.length >0">
                    <md-layout md-flex="50"></md-layout>
                    <md-layout md-flex="45" v-for="(item,index) in viewVgmDoc" :key="index">
                   
                      <a
                         :href="`${docURL}/FF_Sea_Export_Uploads/`+item"
                    
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                    </md-layout>
                  </md-layout> -->

                  <!-- /.box-body -->
                </div>

                <!-- <md-layout md-gutter v-if="ffExportDetail.mergeffExportId!='0'">
                  <md-layout md-flex="5"></md-layout>
                  <label style="color:green;letter-spacing:1px">
                    Note : Your B/L is merge with this
                    <u>{{ffExportDetail.mergeSeries}}</u>
                  </label>
                </md-layout> -->
              </div>
              <div
                class="mt-3"
                v-if="proceedFurther == true && sbDetailArrayList.length > 0"
              >
                <b-button
                  v-if="factoryStuffing.vgmBy != 'SHIPPER'"
                  variant="primary"
                  @click="addFactoryExecution('VGM')"
                  id="addButtonLoaderRail"
                  >Save & Proceed To VGM</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderRail"
                  style="display: none"
                ></md-spinner>
                <br />

                <b-button
                  class="mt-1"
                  variant="primary"
                  @click="addFactoryExecution('PAY')"
                  id="addButtonLoaderVGM"
                  >Save & Proceed To S-Line Payment</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderVGM"
                  style="display: none"
                ></md-spinner>
                <br />
                <!-- v-if="getContainerList.length==0" -->

                <b-button
                  class="mt-1"
                  v-if="ffExportDetail.mergeffExportId == '0'"
                  id="addButtonLoaderBL"
                  variant="primary"
                  @click="addFactoryExecution('BLRaised')"
                  >Save & Proceed to Raise B/L</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loaderBL"
                  style="display: none"
                ></md-spinner>
                <br />
                <!-- v-if="getContainerList.length==0" -->

                <b-button
                  class="mt-1"
                  variant="primary"
                  @click="addFactoryExecution('handover')"
                  id="addButtonLoaderHand"
                  >{{
                    ffExportDetail.portType == "Icd"
                      ? "Save & Proceed to Handover to Rail"
                      : "Save & Proceed to Gate ­ in at Terminal By Road"
                  }}</b-button
                >
                <!-- {{ffExportDetail.portType=='Icd'?"Save & Proceed to Handover to Rail":"Save & Proceed to Gate ­ in at Terminal By Road"}} -->
                <md-spinner
                  md-indeterminate
                  id="loaderHand"
                  style="display: none"
                ></md-spinner>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose7"
      ref="addPop7"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onClose"
    ></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
//import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editFFBookingId") != undefined &&
      this.$sessionsStorage.get("editFFBookingId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ffExecution");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo = newVal.containerNo.toUpperCase();
        }

        if (this.ContainerTypeSizefactory.packageId != "") {
          let arrayNew = this.packageNameList.filter((x) => {
            return x.packageId == this.ContainerTypeSizefactory.packageId;
          });

          if (arrayNew.length > 0) {
            this.ContainerTypeSizefactory.packageName = arrayNew[0].packageName;
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      selectDateFormat,
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      permissionStatus: "",
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      invalidContainerError: false,
      sbDetailArray: [],
      packageNameList: [],
      getContainerList: [],
      vgmArryList: [],
      // getLocationList: [],
      ffExportDetail: {
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        clientName: "",
        ffExportFclSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],
      examinationList: [
        {
          examText: "Yes",
          examValue: "Yes",
        },
        {
          examText: "No",
          examValue: "No",
        },
      ],
      vgmByList: [
        {
          vgmByText: "PRIDEL",
          vgmByValue: "PRIDEL",
        },
        {
          vgmByText: "SHIPPER",
          vgmByValue: "SHIPPER",
        },
      ],

      showMoreSB: false,

      factoryStuffing: {
        allModuleId: "",

        vgmSubmissionDate: "",
        siSubmissionDate: "",
        vgmBy: "",
        vgmUpload: "",
        ffExecutionId: "",
        transportationBy: "",
        CustomerGateIn: "",
        gateInDate: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        examinationComplete: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
      },
      errorAtleastContainer: "",
      errorExecution: {
        transportationBy: "",

        // CustomerGateIn: ""

        //  gateInDate: ""
      },
      ALLMODULE: "",
      JOBSERIES: "",
      SBDetail: {
        examDate: "",
        examinationComplete: "",
        shippingBillUpload: "",
        shippingSBId: "",
        shippingBillDate: "",
        shippingBillNo: "",
        cargoGrossWeight: "",
        LetExport: "",
        invoiceUpload: "",
        cargoUpload: "",
        EnterLet: "",
        shippingInvoiceNo: "",
        shippingInvoiceDate: "",
      },

      errorSBExecution: {
        shippingBillDate: "",
        shippingBillNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      conDetailsTPT: "",

      arrayExecutionError: [
        "Select Transportation By",
        // "Select Customer Gate-In"
        // "Select gate-In date"
      ],
      customerGateLocaList: [],
      pickUpList: [],
      handoverList: [],
      ContainerTypeSizefactory: {
        netWeight: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        PickupLocation: "",
        pickupDate: "",
        StuffingLocation: "",
        stuffingDate: "",
      },
      containerCountWise: [],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
      },
      validContainerNo: "",
      showDivCountNote: false,
      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //   measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      PORTINFO: "",
      mainEntryData: [],
      editIndex: "",
      deleteId: "",
      containerNoRegexError: "",
      nextPageType: "",

      BookingShippingLine: {},
      validateTrans: true,
      containerTypeDetailFactory: [],
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      errorAtleastSb: "",
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    BannerComponent,
   // Loading,
   CustomLoader,
    DocForm,
  },
  computed: {
    proceedFurther() {
      if (this.containerTypeDetailFactory.length > 0) {
        let arrayG = this.containerTypeDetailFactory.filter((x) => {
          return x.containerNo;
        });

        return arrayG.length == this.containerTypeDetailFactory.length ? true : false;
      } else {
        return false;
      }
    },

    viewVgmDoc() {
      return this.factoryStuffing.vgmUpload != "" &&
        this.factoryStuffing.vgmUpload != null
        ? this.factoryStuffing.vgmUpload.split(",")
        : [];
    },
    viewInvoicedDoc() {
      return this.SBDetail.invoiceUpload != "" && this.SBDetail.invoiceUpload != null
        ? this.SBDetail.invoiceUpload.split(",")
        : [];
    },
    viewCargoDoc() {
      return this.SBDetail.cargoUpload != "" && this.SBDetail.cargoUpload != null
        ? this.SBDetail.cargoUpload.split(",")
        : [];
    },
    viewShippingdDoc() {
      return this.SBDetail.shippingBillUpload != "" &&
        this.SBDetail.shippingBillUpload != null
        ? this.SBDetail.shippingBillUpload.split(",")
        : [];
    },

    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    // masterList() {
    //   return this.getLocationList;
    // }
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    addVgmByShipper() {
      //   if (this.factoryStuffing.vgmBy == "SHIPPER") {
      //     let obj = {
      //       vgmUpload: "",
      //       vgmContainerNo: "",
      //       viewVgm: "",
      //     };
      //     this.vgmArryList.push(obj);
      //   }
    },
    addMoreDoc() {
      let obj = {
        vgmUpload: "",
        vgmContainerNo: "",
        viewVgm: "",
      };
      this.vgmArryList.push(obj);
    },
    onFileChange(ID) {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        // formData.append(
        //   "moduleId",
        //   this.$sessionsStorage.get("editExportFCLId") +
        //     "-" +
        //     this.sbDetailArrayList.length +
        //     "-" +
        //     this.SBDetail.shippingSBId
        // );
        if (ID == "Invoice") {
          formData.append(
            "staticFileName",
            "Sea_Export_Fact_ShipperInvoice" + this.sbDetailArrayList.length
          );
        } else if (ID == "Cargo") {
          formData.append(
            "staticFileName",
            "Sea_Export_Fact_Cargolist" + this.sbDetailArrayList.length
          );
        } else if (ID == "VGMBYSHIPPER") {
          formData.append(
            "staticFileName",
            "Sea_Export_Fact_VGMBYSHIPPER" + this.sbDetailArrayList.length
          );
        } else {
          formData.append(
            "staticFileName",
            "Sea_Export_Fact_ShippingBill" + this.sbDetailArrayList.length
          );
        }

        //  formData.append("upload_dir_folderName", "FF_Sea_Export_Uploads");
        formData.append(
          "upload_dir_folderName",
          this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "Invoice") {
            this.SBDetail.invoiceUpload = result.data;
          } else if (ID == "Cargo") {
            this.SBDetail.cargoUpload = result.data;
          } else if (ID == "VGMBYSHIPPER") {
            this.factoryStuffing.vgmUpload = result.data;
          } else {
            this.SBDetail.shippingBillUpload = result.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    onFileChangeVgm(index) {
      var files = event.target.files || event.dataTransfer.files;
      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("staticFileName", "Sea_Export_Fact_ShipperVGM" + index);
        formData.append(
          "upload_dir_folderName",
          this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          this.vgmArryList[index].viewVgm = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
        //  alert(this.validContainerNo);
      }
    },
    openPop() {
      this.alert.content = "Send Assignment Details To Client ..?";
      this.$refs["popMail"].open();
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let shipperInvoiceNoArry = [];
        let containerNoArry = [];
        let customSealNoArry = [];
        let lineSealNoArry = [];
        let shippingBillNoArry = [];
        let shippingBillDateArry = [];

        this.sbDetailArray.map((x) => {
          shipperInvoiceNoArry.push(x.shippingInvoiceNo);
          shippingBillNoArry.push(x.shippingBillNo);
          shippingBillDateArry.push(x.shippingBillDate);
        });
        this.containerTypeDetailFactory.map((x) => {
          containerNoArry.push(x.containerNo);
          customSealNoArry.push(x.customSealNo);
          lineSealNoArry.push(x.LineSealNo);
        });

        let newData = {
          mail: "FF",
          clientName: this.ffExportDetail.clientName,
          assignmentNo: this.ffExportDetail.ffExportFclSeries,
          POR: this.ffExportDetail.POR,
          FinalPlace: this.ffExportDetail.FinalPlace,
          shippingLine: this.ffExportDetail.shippingLine,
          wareHouseExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
          ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
          containerNoArry: containerNoArry,
          lineSealNoArry: lineSealNoArry,
          customSealNoArry: customSealNoArry,
          shipperInvoiceNoArry: shipperInvoiceNoArry,
          sLineBookingNo: this.BookingShippingLine.bookingNumber,
          vesselName: this.BookingShippingLine.vesselName,
          voyyageNo: this.BookingShippingLine.voyageNo,
          suCutoff: this.BookingShippingLine.SICutOff,
          noOfContainers: containerNoArry.length,
          shippingBillDateArry: shippingBillDateArry,
          shippingBillNoArry: shippingBillNoArry,
        };

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendExecutionDetailsToClient.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    previousSalesView() {
      window.history.go(-1);
      // if (this.ffExportDetail.containerInfo == "lcl") {
      //   this.$router.push({
      //     path: "/freightForward/ffExportFcl",
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffBooking",
      //   });
      // }
    },

    onClose(type) {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$sessionsStorage.set("editSalesExId", this.ALLMODULE);
      if (type != "cancel") {
        if (
          //this.ffExportDetail.portType == "Icd" &&
          this.nextPageType == "handover"
        ) {
          this.$router.push({
            path: "/freightForward/handoverToRail",
          });
        } else if (this.nextPageType == "VGM") {
          this.$router.push({
            path: "/freightForward/vgmDetail",
          });
        } else if (this.nextPageType == "BLRaised") {
          this.$router.push({
            path: "/freightForward/fclBLofLanding",
          });
        } else if (this.nextPageType == "PAY") {
          this.$router.push({
            path: "/freightForward/ffSLinePaymentExport",
          });
        }
      }
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_execution_container",
          tableId: "ffExecutionContainerId",
          isActive: "isActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              // this.JqueryFun();
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => {});
      }
    },

    onClose7(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_execution_sb",
          tableId: "shippingSBId",
          isActive: "isAcitveSB",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // this.JqueryFun();
              this.getData();
              this.deleteId = "";
            }
          })
          .catch((error) => {});
      }
    },
    viewEditSB(id, index) {
      let array = this.sbDetailArray.filter((x) => {
        return x.shippingSBId == id;
      });

      Object.keys(this.SBDetail).map((x) => {
        this.SBDetail[x] = array[0][x];
      });
    },
    DeleteListSb(id, index) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop7"].open();
    },
    validateExecution() {
      let validate_new = true;
      Object.keys(this.errorExecution).map((x, index) => {
        if (this.factoryStuffing[x] == "") {
          this.errorExecution[x] = this.arrayExecutionError[index];
          validate_new = false;
        }

        if (this.containerTypeDetailFactory.length == 0) {
          this.errorAtleastContainer = "Select Atleast one Container";

          validate_new = false;
        } else {
          this.errorAtleastContainer = "";
        }

        if (this.sbDetailArrayList.length == 0) {
          this.showMoreSB = true;
          this.errorAtleastSb = "Add Atleast one S/B Detail";
          validate_new = false;
        } else {
          this.errorAtleastSb = "";
          this.showMoreSB = false;
        }
      });

      if (validate_new == false) {
        window.scroll(0, 50);

        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    addSBDetail() {
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.invoiceUpload) {
        let obj = {
          allModuleId: this.ALLMODULE,
          docName: "FF_SEA_EX_SHIPPER_INVOICE",
          docLink: this.SBDetail.invoiceUpload,
        };
        this.SBDetail.uploadArray.push(obj);
      }
      if (this.SBDetail.cargoUpload) {
        let obj1 = {
          allModuleId: this.ALLMODULE,
          docName: "BL_LINEINVOICEREQ",
          docLink: this.SBDetail.cargoUpload,
        };
        this.SBDetail.uploadArray.push(obj1);
      }
      if (this.SBDetail.shippingBillUpload) {
        let obj2 = {
          allModuleId: this.ALLMODULE,
          docName: "FF_SEA_EX_SB",
          docLink: this.SBDetail.shippingBillUpload,
        };
        this.SBDetail.uploadArray.push(obj2);
      }

      let new_data = {
        SBDetail: this.SBDetail,
        factoryStuffing: this.factoryStuffing,
      };

      this.validateSBDetail();
      if (this.validateSB != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addSBFactoryExecution.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // this.$sessionsStorage.set(
              //   "editFFExecutionId",
              //   data.ffExecutionId
              // );
              // this.factoryStuffing.ffExecutionId = data.ffExecutionId;
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }

              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = "";
              });
              Object.keys(this.errorSBExecution).map((x) => {
                this.errorSBExecution[x] = "";
              });
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    addFactoryExecution(id) {
      this.factoryStuffing["vgmArryList"] = this.vgmArryList;
      this.factoryStuffing.portType = this.PORTINFO;

      this.nextPageType = id;
      if (
        this.nextPageType == "handover" &&
        this.factoryStuffing.vgmSubmissionDate == ""
      ) {
        this.alert.content =
          "VGM Submission Date  must be entered before proceeding to Handover";
        this.$refs["addPop"].open();
        return false;
      }

      // if (
      //   this.nextPageType == "handover" &&
      //   this.factoryStuffing.examinationComplete == "No"
      // ) {
      //   this.alert.content = "Examination is not Completed";
      //   this.$refs["addPop"].open();
      //   return false;
      // }
      this.validateExecution();

      if (this.validateTrans != false) {
        if (id == "handover") {
          $("#addButtonLoaderHand").css("display", "none");
          $("#loaderHand").css("display", "block");
        }
        if (id == "BLRaised") {
          $("#addButtonLoaderBL").css("display", "none");
          $("#loaderBL").css("display", "block");
        }
        if (id == "VGM") {
          $("#addButtonLoaderRail").css("display", "none");
          $("#loaderRail").css("display", "block");
        }
        console.log(this.factoryStuffing);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addExecutionFacftory.php`,
          data: JSON.stringify(this.factoryStuffing),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // this.$sessionsStorage.set(
              //   "editFFExecutionId",
              //   data.ffExecutionId
              // );
              // this.factoryStuffing.ffExecutionId = data.ffExecutionId;
              if (id == "VGM") {
                $("#loaderRail").css("display", "none");
                $("#addButtonLoaderRail").css("display", "block");
              }
              if (id == "handover") {
                $("#loaderHand").css("display", "none");
                $("#addButtonLoaderHand").css("display", "block");
              }

              if (id == "BLRaised") {
                $("#loaderBL").css("display", "none");
                $("#addButtonLoaderBL").css("display", "block");
              }

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop2"].open();
              }
              if (this.nextPageType == "SAVE") {
                this.getData();
              }
            }
          })
          .catch((error) => {});
      }
    },
    validateContainer() {
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      let validate_new = true;
      Object.keys(this.errorContainer).map((x, index) => {
        if (this.ContainerTypeSizefactory[x] == "") {
          this.errorContainer[x] = this.arrayContainerError[index];
          validate_new = false;
        }
      });

      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
        validate_new = false;
      } else if (containerformat.test(this.ContainerTypeSizefactory.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
        validate_new = false;
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );

      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      // var re = new RegExp("/\b" + test + "\b/");
      let array = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        array = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        array.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (
        containerformat.test(this.ContainerTypeSizefactory.containerNo)
        // &&
        // lastDigitCon == lastDigitReturn
      ) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    factoryStuffingContainer() {
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        let AlreadyCon = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
        if (AlreadyCon.length > 0) {
          this.alert.content = " Container No. Already Exists";
          this.$refs["addPop"].open();
          return false;
        }
      }

      if (this.getContainerList.length > 0) {
        let array_new = this.getContainerList;
        if (this.ContainerTypeSizefactory.containerTypeId != "") {
          let new_array = array_new.filter((x) => {
            return x.containerTypeId == this.ContainerTypeSizefactory.containerTypeId;
          });
          if (new_array.length > 0) {
            this.ContainerTypeSizefactory.containerType = new_array[0].containerType;
          }
        }
      }
      this.factoryStuffing.allModuleId = this.ALLMODULE;
      let new_data = {
        ContainerTypeSizefactory: this.ContainerTypeSizefactory,
        factoryStuffing: this.factoryStuffing,
      };

      // if (this.invalidContainerError == true) {
      //   this.alert.content = "Invalid Container No";
      //   this.$refs["addPop"].open();
      //   return false;
      // }

      this.validateContainer();
      if (this.validateTrans != false) {
        $("#addButtonLoaderCon").css("display", "none");
        $("#loaderCon").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addFactoryContainer.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // this.$sessionsStorage.set(
              //   "editFFExecutionId",
              //   data.ffExecutionId
              // );
              // this.factoryStuffing.ffExecutionId = data.ffExecutionId;
              $("#loaderCon").css("display", "none");
              $("#addButtonLoaderCon").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }

              // Object.keys(this.removeContainerVmodel).map(x => {
              //   this.ContainerTypeSizefactory[x] = "";
              // });

              // Object.keys(this.errorContainer).map(x => {
              //   this.errorContainer[x] = "";
              // });

              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    DeleteList(id, index) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ffExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
    },
    getData() {
      this.doLoading();

      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        exPage: "1",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId:
          this.$sessionsStorage.get("editFFBookingId") != "" &&
          this.$sessionsStorage.get("editFFBookingId") != undefined
            ? this.$sessionsStorage.get("editFFBookingId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.editFFEX.length > 0) {
              this.mainEntryData = data.editFFEX;
              this.PORTINFO = data.editFFEX[0].portType;
              this.factoryStuffing.portType = data.editFFEX[0].portType;
              this.ALLMODULE = data.editFFEX[0].allModuleId;
              this.JOBSERIES = data.editFFEX[0].ffExportFclSeries;

              this.factoryStuffing.stuffingType = data.editFFEX[0].stuffingType;
              this.factoryStuffing.containerInfo = data.editFFEX[0].containerInfo;
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
            }
            if (data.ContainerFromTPT.length > 0) {
              // if (!this.$sessionsStorage.get("editFFExecutionId")) {
              //   this.$sessionsStorage.set(
              //     "editFFExecutionId",
              //     data.autoExecutionId
              //   );
              // }
              this.ContainerFromTPT = data.ContainerFromTPT;

              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            if (data.containerCountWise && data.containerCountWise.length > 0) {
              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }
            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (
              this.$sessionsStorage.get("editFFExecutionId") != "" &&
              this.$sessionsStorage.get("editFFExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              if (data.LocationDetailsFinal.length > 0) {
                this.customerGateLocaList = data.LocationDetailsFinal;
                this.pickUpList = data.LocationDetailsFinal;
                this.handoverList = data.LocationDetailsFinal;
              }
            }

            // this.JqueryFun();

            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    viewExecutionDetail() {
      this.vgmArryList = [];
      let new_data = {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        newData: this.ffExportDetail,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewExecutionDetail.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            Object.keys(this.factoryStuffing).map((x) => {
              this.factoryStuffing[x] = data.ffExecutionDetail[0][x] || "";
            });

            if (data.ffExecutionDetail.length > 0) {
              if (data.ffExecutionDetail[0].vgmUpload) {
                let vg = data.ffExecutionDetail[0].vgmUpload.split(",");
                let vgC = [];
                if (data.ffExecutionDetail[0].vgmContainerNo) {
                  vgC = data.ffExecutionDetail[0].vgmContainerNo.split(",");
                }

                for (let i = 0; i < vg.length; i++) {
                  let obj = {
                    vgmUpload: vg[i],
                    vgmContainerNo: vgC[i],
                    viewVgm: vg[i],
                  };
                  this.vgmArryList.push(obj);
                }
              }
            }

            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
              console.log(this.containerTypeDetailFactory, "test");

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ffExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ffSBDetail.length > 0) {
              this.sbDetailArray = data.ffSBDetail;
            }

            if (data.LocationDetailsFinal.length > 0) {
              this.customerGateLocaList = data.LocationDetailsFinal;
              this.pickUpList = data.LocationDetailsFinal;
              this.handoverList = data.LocationDetailsFinal;
            }
          }
        })
        .catch((error) => {});
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffExecution.vue?5a23b416